import { Agent } from 'sb-lib/types';
import { SelfUser, User } from 'types/user';

/**
 * Convert FE User or SelfUser to the Widget representation "Agent".
 *
 * Ideally they'd have the exact same shape, but they have diverged.
 *
 * @param user of type User | SelfUser
 * @returns agent of type Agent
 */
export function userToAgent(user: SelfUser | User): Agent {
  const { id, displayName, title, avatar, onCall } = user;
  return {
    id,
    name: displayName,
    title,
    avatar: avatar?.imageUrl,
    sid: ('sid' in user && user.sid) || undefined,
    available: undefined,
    onCall,
  };
}
